import { Box, useTheme } from '@mui/material';
import { useMediaQuery } from '@mui/material';
import { Link, styled, Typography } from '@mui/material';
import React from 'react';
import { Link as LinkRouter } from 'react-router-dom';
import { getPolyglot } from '../../../../i18n';

export const LinkStyled = styled(Link)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    fontSize: theme.typography.body2.fontSize,
  },
})) as typeof Link;
export interface AuthLayoutFooterProps {
  urlAboutUs?: string;
  urlStatus?: string;
}
export function AuthLayoutFooter(props: AuthLayoutFooterProps) {
  const {
    urlAboutUs = 'http://stoerk-tronic.com/',
    urlStatus = 'https://stats.uptimerobot.com/xxuCT7SMXT',
  } = props;
  const theme = useTheme();
  const polyglot = getPolyglot();
  return (
    <Box
      display={'flex'}
      flexWrap={'wrap'}
      sx={{
        '& .MuiTypography-root': {
          fontSize: '0.8rem',
        },
      }}
    >
      <LinkStyled to="/terms-and-conditions" component={LinkRouter}>
        {polyglot.t('footer.terms_and_conditions')}
      </LinkStyled>
      <Typography color={theme.palette.primary.main} px={0.2}>
        {'·'}
      </Typography>
      <LinkStyled to="/privacy" component={LinkRouter}>
        {polyglot.t('footer.privacy_policy')}
      </LinkStyled>
      <Typography color={theme.palette.primary.main} px={0.2}>
        {'·'}
      </Typography>
      <LinkStyled to="/cookies" component={LinkRouter}>
        {polyglot.t('footer.cookie_policy')}
      </LinkStyled>
      <Typography color={theme.palette.primary.main} px={0.2}>
        {'·'}
      </Typography>
      <LinkStyled to="/impressum" component={LinkRouter}>
        {polyglot.t('footer.impressum')}
      </LinkStyled>
      <Typography color={theme.palette.primary.main} px={0.2}>
        {'·'}
      </Typography>
      <LinkStyled px={0.2} href={urlAboutUs} target={'_blank'}>
        {polyglot.t('footer.about_us')}
      </LinkStyled>
      <Typography color={theme.palette.primary.main} px={0.2}>
        {'·'}
      </Typography>
      <LinkStyled px={0.2} href={urlStatus} target={'_blank'}>
        {polyglot.t('footer.status')}
      </LinkStyled>
    </Box>
  );
}
